import PostService from '@/services/PostService';

export default {
  namespaced: true,
  state: {
    isRestricted: false,
    loaded: false,
  },
  getters: {
    isRestricted: state => state.isRestricted,
  },
  mutations: {
    SET_RESTRICTED(state, value) {
      state.isRestricted = !!value;
      state.loaded = true;
    },
  },
  actions: {
    async fetchRestrictionStatus({ commit }) {
      try {
        const res = await PostService.getRestrictionStatus();
        commit('SET_RESTRICTED', res.data?.restricted || false);
      } catch (err) {
        console.error('Error fetching restriction status:', err);
        commit('SET_RESTRICTED', false);
      }
    },
  },
};
